import React from 'react';
import PropTypes from 'prop-types';
import CartIcon from '@tradera/blueprint/theme/icons2/cart.svg?jsx';
import { useTranslator, useUrlLocalizer } from 'static/script/app/lang';

const CartLink = ({ formattedCartItems, cartSum }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            href={toLocalizedUrl('/Shopping/CartOverview')}
            aria-label="Mitt Tradera"
            className="slim-header__menu-link slim-header__cart-link pl-xl-3 px-1 mr-md-0 mr-2 d-flex position-relative align-items-center"
            data-ga-category="Top navigation"
            data-ga-action="Cart"
            data-ga-label="Link - Cart with items from NavBar">
            <span className="slim-header__notification-cart badge badge-primary badge-pill-round badge-pill-round-sm">
                {formattedCartItems}
            </span>
            <button className="btn btn-branded btn-round">
                <CartIcon className="icon" />
            </button>
            <div className="slim-header__link-text d-none d-xl-inline">
                <span className="bold">
                    {t('siteHeader_cart')} <br />
                    {cartSum} kr
                </span>
            </div>
        </a>
    );
};

CartLink.propTypes = {
    formattedCartItems: PropTypes.number,
    cartSum: PropTypes.string
};

export default CartLink;
